import { AvField, AvForm } from "availity-reactstrap-validation";
import { Spinner } from "reactstrap";
import { MEASURE_TYPE_OPTIONS } from "../helpers/measureList";
import { ADOPTION_TYPE_OPTIONS } from "../helpers/measureForm";

const MeasureFormFields = ({
    formKey,
    defaultValues = {},
    adoptionLocked = false,
    allowEmptyAdoption = false,
    splitFields = false,
    isSaving = false,
    onSubmit,
    onCancel,
    t,
}) => {
    const typeField = (
        <AvField
            type="select"
            name="measureType"
            label={t("Type")}
            value={defaultValues.measureType || ""}
            errorMessage={t("Measure type is required.")}
            validate={{
                required: {
                    value: true,
                    errorMessage: t("Measure type is required."),
                },
            }}
        >
            <option value="">{t("Select")}</option>
            {MEASURE_TYPE_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                    {t(option.labelKey)}
                </option>
            ))}
        </AvField>
    );
    const adoptionField = (
        <AvField
            type="select"
            name="adoptionType"
            label={t("Adoption type")}
            value={defaultValues.adoptionType || ""}
            disabled={adoptionLocked}
        >
            {allowEmptyAdoption && (
                <option value="">{t("Not set")}</option>
            )}
            {ADOPTION_TYPE_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                    {t(option.labelKey)}
                </option>
            ))}
        </AvField>
    );

    return (
        <AvForm
            key={formKey}
            className="needs-validation positive-list-form"
            onValidSubmit={onSubmit}
        >
            <AvField
                name="title"
                label={t("Title")}
                value={defaultValues.title || ""}
                errorMessage={t("Title is required.")}
                validate={{
                    required: {
                        value: true,
                        errorMessage: t("Title is required."),
                    },
                }}
            />

            {splitFields ? (
                <div className="row">
                    <div className="col-md-6">{typeField}</div>
                    <div className="col-md-6">{adoptionField}</div>
                </div>
            ) : (
                <>
                    {typeField}
                    {adoptionField}
                </>
            )}

            <AvField
                type="textarea"
                name="description"
                label={t("Description")}
                value={defaultValues.description || ""}
                rows="3"
            />

            {adoptionLocked && (
                <small className="text-muted d-block">
                    {t("Adoption type is set by the catalog and cannot be changed.")}
                </small>
            )}

            <div className="d-flex justify-content-end gap-2 mt-4">
                <button
                    type="button"
                    className="btn btn-outline-secondary"
                    disabled={isSaving}
                    onClick={onCancel}
                >
                    {t("Cancel")}
                </button>
                <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isSaving}
                >
                    {isSaving && (
                        <Spinner size="sm" className="me-1" />
                    )}
                    {t("Save")}
                </button>
            </div>
        </AvForm>
    );
};

export default MeasureFormFields;
